import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-type-decimal",
  "use": "icon-type-decimal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-type-decimal\"><path d=\"M10.062 4q.561.038.953.485.39.449.391 1.122v4.785q0 .673-.391 1.122a1.34 1.34 0 0 1-.953.486H8.75a1.35 1.35 0 0 1-.954-.485q-.39-.448-.39-1.122V5.607q0-.673.39-1.122.391-.448.954-.485zM8.75 10.5h1.313v-5H8.75zM5 10.393h1.406V12H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol